import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';

interface DialogActionButtonsProps {
  activeStep: number;
  steps: string[];
  isLoading: boolean;
  isUploading: boolean;
  onBack: () => void;
  onClose: () => void;
  onUploadAttachments: () => void;
  onNext: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
  activeStep,
  steps,
  isLoading,
  isUploading,
  onBack,
  onClose,
  onUploadAttachments,
  onNext
}) => {  return (
    <>
      <Button
        className="ticketEasy-module"
        color="inherit"
        variant="outlined"
        disabled={activeStep === 0 || isLoading || isUploading}
        onClick={onBack}
        sx={{ mr: 1, borderRadius: 1, px: 3 }}
      >
        Back
      </Button>
      <Box sx={{ flexGrow: 1 }} />
      <Button
        onClick={onClose}
        color="secondary"
        variant="outlined"
        disabled={isLoading || isUploading}
        sx={{ borderRadius: 1, px: 3, mr: 1 }}
      >
        {activeStep === steps.length - 1 ? 'Close' : 'Cancel'}
      </Button>
        {activeStep === 0 && (
        <Button
          className="ticketEasy-module"
          type="submit"
          form="ticket-form"
          color="primary"
          variant="contained"
          disabled={isLoading}
          sx={{ 
            borderRadius: 1,
            px: 3,
            boxShadow: '0px 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          {isLoading ? <CircularProgress size={24} /> : 'Next'}
        </Button>
      )}
        {activeStep === 1 && (
        <Button
          className="ticketEasy-module"
          color="primary"
          variant="contained"
          onClick={onUploadAttachments}
          disabled={isLoading || isUploading}
          sx={{ 
            borderRadius: 1,
            px: 3,
            boxShadow: '0px 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          {isLoading ? (
            <CircularProgress size={24} />
          ) : 'Next'}
        </Button>
      )}
      
      {activeStep === 2 && (
        <Button
          className="ticketEasy-module"
          color="primary"
          variant="contained"
          onClick={onNext}
          disabled={isLoading}
          sx={{ 
            borderRadius: 1,
            px: 3,
            boxShadow: '0px 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          Next
        </Button>
      )}
      
      {activeStep === 3 && (
        <Button
          className="ticketEasy-module"
          color="primary"
          variant="contained"
          onClick={onClose}
          sx={{ 
            borderRadius: 1,
            px: 3,
            boxShadow: '0px 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          Finish
        </Button>
      )}
    </>
  );
};